// 9fbef606107a605d69c0edbcd8029e5d 
import React from 'react';
import LoaderSkelton from '@tcp/core/src/components/common/molecules/LoaderSkelton';

const EarnExtraPointsTileSkeleton = () => {
  return <LoaderSkelton width="70%" height="280px" />;
};

export default EarnExtraPointsTileSkeleton;
